import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { parseCookies } from 'nookies'
import {
  getProxyImage
} from '@/infra/services'
import { useEffect, useState } from 'react'

export const useGetImageProxy = (imageSrc) => {
  const queryClient = useQueryClient()
  const [previousUserId, setPreviousUserId] = useState(null)
  const cookies = parseCookies()
  const queryKey = [imageSrc]
  const { data, isPending, isFetching, refetch, isRefetching, isSuccess, dataUpdatedAt } = useQuery({
    queryKey,
    queryFn: () => getProxyImage(imageSrc),
    refetchOnWindowFocus: false, // No refetch on window focus
    retry: true, // No retries on failure
    enabled: false
  })
  const remove = () => queryClient.removeQueries({ queryKey, exact: true })

  // v5 removed onSuccess from useQuery; invalidate after each successful fetch instead
  useEffect(() => {
    if (isSuccess) queryClient.invalidateQueries({ queryKey })
  }, [isSuccess, dataUpdatedAt])

  return {
    isLoading: isPending,
    isFetching,
    refetch,
    isRefetching,
    remove,
    isSuccess,
    data
  }
}
